import { codes, statusShortCode } from 'constants/payment';
import { SILVER_VOUCHER_DISCOUNT_DESCRIPTION, VOUCHER_TYPE_DISCOUNT } from 'constants/vouchers';

export const hasSilverVoucherApplied = (vouchers = [], payments = []) =>
  vouchers.some(
    ({ paymentId, isActive, class: voucherType, description }) =>
      isActive === true &&
      voucherType === VOUCHER_TYPE_DISCOUNT &&
      description === SILVER_VOUCHER_DISCOUNT_DESCRIPTION &&
      payments
        .filter(({ method, paymentStatus }) => method === codes.VOUCHER && paymentStatus === statusShortCode.success)
        .some(({ id }) => id === paymentId)
  );
